// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { warning } from 'react-notification-system-redux'
import { fetchContactById } from 'helpers/api'
import { useLoadingToggler } from 'hooks'

// when this mounts, it calls for the contact's details then returns them.
// If the API request fails, it triggers closeModal and calls it a day.

const useContactDetails = ({ closeModal, contactId }) => {
  const dispatch = useDispatch()
  const loadingToggler = useLoadingToggler()

  const [contactData, setContactData] = useState(null)

  useEffect(() => {
    loadingToggler(
      async () => {
        try {
          const { entity } = await fetchContactById(contactId)
          setContactData(entity)
        } catch (err) {
          console.warn(err)

          dispatch(warning({
            message: err.message,
            title: 'Failed to load Contact Details.',
          }))
          closeModal()
        }
      }
    )
  }, [])

  return contactData
}

export default useContactDetails
